<template>
  <div class="b-settings__block p-6 pb-8 mt-6">
    <h2 class="mb-4">{{$t('CONTENT.settingsPage.counterparty_group')}}</h2>
    <div v-if="error" class="mb-2">
      <server-error :error="error" />
    </div>
    <form v-if="isLoaded" class="b-form p-0" @submit.prevent="onSubmit">
      <div class="b-settings__block-box row row-no-flex">
        <div class="col-3">
          <div class="b-form__container">
            <label>{{ $t('CONTENT.settingsPage.counterparty_group_choose_company') }}:</label>
          </div>
        </div>
        <div :key="counter">
          <div
            v-for="(item, itemIndex) in counterpartyGroup"
            :key="itemIndex"
            class="b-settings__block-item"
          >
            <div class="row mx-0 mb-5 b-form__container_type_flex">
              <div class="col-5 pr-2">
                <CounterpartyItem
                  :ref="`setting-counterparty-${itemIndex}`"
                  :is-read-only-mode="isReadOnlyMode"
                  :counterparty-item="item"
                  :counterparty-item-index="itemIndex"
                  @selectCounterparty="onSelectCounterparty"
                />
              </div>
              <div class="pr-2" v-if="!isReadOnlyMode">
                <button
                  type="button"
                  class="b-btn b-btn_type_add"
                  @click="openCounterPartyDialog(itemIndex)"
                >
                  <dynamic-icon
                    class="b-btn__icon b-btn__icon_color_main-text"
                    icon="plus"
                  />
                </button>
              </div>
              <div class="pr-6" v-if="!isReadOnlyMode">
                <button
                  type="button"
                  :data-cy="`import-counterparty-${itemIndex}`"
                  class="b-btn b-btn_type_add"
                  @click="openImportDialog"
                >
                  <dynamic-icon
                    class="b-btn__icon b-btn__icon_color_main-text"
                    icon="xls"
                  />
                </button>
              </div>
              <div>{{ getType(item) }}</div>
              <div v-if="!isReadOnlyMode">
                <button
                  class="b-btn b-btn_border_none b-btn_type_icon_accent_color"
                  @click="openEditDialog(item, 'edit')"
                >
                  <dynamic-icon
                    class="b-btn__icon"
                    icon="edit"
                  />
                </button>
              </div>
              <button
                v-if="counterpartyGroup.length > 1 && !isReadOnlyMode"
                type="button"
                class="b-btn b-btn_border_none"
                @click="openEditDialog(item, 'delete')"
              >
                <dynamic-icon
                  class="b-btn__icon"
                  icon="close"
                />
              </button>
            </div>
            <popup
              :name="`counterparty-popup-${itemIndex}`"
              height="auto"
              :scrollable="true"
            >
              <server-error :error="error" />
              <GeneralForm
                v-if="isCounterPartyShow"
                :counterparty="counterpartyForForm"
                :counterpartyVatHistoryList="counterpartyVatHistoryList"
                @createNewCounterparty="onCreateCounterparty(itemIndex)"
                @openVatSettings="openVatSettings"
                @close="closeCounterPartyDialog(itemIndex)"
              />
            </popup>
          </div>
        </div>
        <div class="row mx-0 mt-4">
          <div class="col-3">
            <div class="b-form__container">
              <button
                v-if="!isReadOnlyMode"
                type="button"
                class="b-btn"
                :disabled="isDisabledAddCounterpartyItem"
                @click="addCounterpartyItem"
              >
                <dynamic-icon
                  class="b-btn__icon b-btn__icon_color_main-text"
                  icon="plus"
                />
                {{ $t('CONTENT.contract.add_lessor') }}
              </button>
            </div>
          </div>
        </div>
        <div v-if="error">
          <server-error :error="error" />
        </div>
      </div>
      <button
        v-if="!isReadOnlyMode"
        class="b-btn b-btn_type_primary mt-5"
        type="submit"
        data-cy="next-step"
        :disabled="isDisabledSaveBtn"
      >
        {{ $t('CONTENT.save') }}
      </button>
    </form>
    <popup
      name="counterparty-import-popup"
      height="auto"
      :scrollable="true"
    >
      <ImportDialogWidget
        v-if="isShowImportDialog"
        :import-type="'counterparty'"
        @close="closeImportDialog"
      />
    </popup>
    <popup
      name="counterparty-edit-popup"
      height="auto"
      :scrollable="true"
    >
      <EditCounterpartyGroupWidget
        v-if="isShowEditDialog"
        :item="selectedItem"
        :mode="mode"
        @counterpartySaved="updateCounterpartyItem"
        @enableSaveDate="enableSaveBtn"
        @close="closeEditDialog"
      />
    </popup>
    <popup
      name="vat-settings-group-popup"
      height="auto"
      :scrollable="true"
    >
      <VatSettingsForm
        v-if="isVatSettingsOpen"
        :rates="counterpartyVatHistoryList"
        :counterparty-type-id="counterpartyForForm ? counterpartyForForm.idInDB : null"
        :is-create="!counterpartyForForm || !counterpartyForForm.idInDB"
        @close="closeVatSettings"
        @saveVatRates="updateVatRates"
      />
    </popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ImportDialogWidget from '../widgets/ImportDialogWidget';
import EditCounterpartyGroupWidget from '../widgets/EditCounterpartyGroupWidget';
import GeneralForm from '../directories/counterparty/edit/GeneralForm';
import VatSettingsForm from '../directories/counterparty/edit/VatSettingsForm';
import CounterpartyItem from './CounterpartyItem';

export default {
  components: {
    ImportDialogWidget,
    EditCounterpartyGroupWidget,
    GeneralForm,
    VatSettingsForm,
    CounterpartyItem,
  },
  props: {
    counterpartyGroup: {
      type: Array,
    },
    isReadOnlyMode: {
      type: Boolean,
    },
  },
  data() {
    return {
      error: null,
      isShowImportDialog: false,
      isShowEditDialog: false,
      selectedItem: null,
      mode: null,
      isCounterPartyShow: false,
      counterpartyForForm: null,
      isVatSettingsOpen: false,
      counterpartyVatHistoryList: [],
      isDisabledSaveBtn: true,
      shouldSubmit: true,
      counter: 0,
    };
  },
  computed: {
    ...mapGetters(['getCounterpartiresForContract']),
    isDisabledAddCounterpartyItem() {
      return this.counterpartyGroup[this.counterpartyGroup.length - 1].counterpartyId === null;
    },
  },
  methods: {
    enableSaveBtn() {
      this.isDisabledSaveBtn = false;
    },
    updateCounterpartyItem(updatedItem) {
      const index = this.counterpartyGroup.findIndex(item => item === this.selectedItem);
      if (index !== -1) {
        this.$set(this.counterpartyGroup, index, updatedItem);
      }
    },
    getType(item) {
      switch (item.counterpartyTypeId) {
        case 1:
          return this.$t('CONTENT.reportPage.Vgo');
        case 0:
          return this.$t('CONTENT.reportPage.Related');
        case 2:
          return this.$t('CONTENT.reportPage.ThirdParty');
      }
    },
    onSelectCounterparty() {
      this.isDisabledSaveBtn = false;
    },
    addCounterpartyItem() {
      const item = {
        counterpartyId: null,
        counterpartyTypeId: 1,
      };
      this.counterpartyGroup.push(item);
      this.isDisabledSaveBtn = true;
      this.counter++;
      this.openEditDialog(item, 'edit');
    },
    openCounterPartyDialog(index) {
      this.counterpartyVatHistoryList = [];
      this.isCounterPartyShow = true;
      this.$modal.show(`counterparty-popup-${index}`);
    },
    closeCounterPartyDialog(index) {
      this.isCounterPartyShow = false;
      this.counterpartyForForm = null;
      this.$modal.hide(`counterparty-popup-${index}`);
    },
    openVatSettings() {
      this.isVatSettingsOpen = true;
      this.$modal.show('vat-settings-group-popup');
    },
    closeVatSettings() {
      this.isVatSettingsOpen = false;
      this.$modal.hide('vat-settings-group-popup');
    },
    updateVatRates(rates) {
      this.counterpartyVatHistoryList = rates;
    },
    openImportDialog() {
      this.isShowImportDialog = true;
      this.$modal.show('counterparty-import-popup');
    },
    async closeImportDialog() {
      await this.$store.dispatch('getAllCounterparties');
      this.isShowImportDialog = false;
      this.$modal.hide('counterparty-import-popup');
    },
    openEditDialog(item, mode) {
      this.selectedItem = item;
      this.mode = mode;
      if(mode == 'delete') {
        item.counterpartyTypeId = 2;
      }
      this.shouldSubmit = false;
      this.isShowEditDialog = true;
      this.$modal.show('counterparty-edit-popup');
    },
    async closeEditDialog() {
      await this.$store.dispatch('getAllCounterparties');
      this.isShowEditDialog = false;
      this.$modal.hide('counterparty-edit-popup');
      this.shouldSubmit = true;
    },
    async onCreateCounterparty(index) {
      this.setNewCounterparty(index);
      this.isDisabledSaveBtn = false;
    },
    async setNewCounterparty(index) {
      await this.$store.dispatch('getAllCounterparties');
      this.$refs[`setting-counterparty-${index}`].currentCounterpartyId = this.getCounterpartiresForContract[0].id;
      this.counterpartyGroup[index].counterpartyId = this.getCounterpartiresForContract[0].id;
    },
    async onSubmit() {
      if (this.shouldSubmit) {
        for (let i = 0; i < this.counterpartyGroup.length; i++) {
          if (this.counterpartyGroup[i].counterpartyId === null) {
            this.counterpartyGroup.splice(i, 1);
          }
        }
        try {
          this.error = null;
          this.$loadingManager.addLoadingStep();
          await this.$store.dispatch('saveCounterpartyGroup', this.counterpartyGroup);
          this.$loadingManager.loadingStepLoaded();
        } catch (e) {
          this.$loadingManager.hideLoadScreen();
          this.error = e;
        }
      }
    },
  },
};
</script>
